
import { ParallaxEffect, ParallaxContext } from '@/render/parallax/ParallaxEffect';
import { BaseParallaxEffect } from '@/render/parallax/BaseParallaxEffect';

export class CircuitBoardEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
        const spacing = (200 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);

        ctx.strokeStyle = pc.color;
        ctx.fillStyle = pc.color;
        ctx.lineWidth = 2 * (config.parallaxScale || 1.0);

        for (let x = x1; x <= x2; x += spacing) {
            for (let y = y1; y <= y2; y += spacing) {
                const draw = () => {
                    ctx.beginPath();
                    ctx.arc(x, y, 4 * (config.parallaxScale || 1.0), 0, Math.PI * 2);
                    ctx.fill();
                    
                    ctx.beginPath();
                    ctx.moveTo(x, y);
                    if (this.pseudoRandom(x + y) > 0.5) {
                        ctx.lineTo(x + spacing, y);
                    } else {
                        ctx.lineTo(x, y + spacing);
                    }
                    ctx.stroke();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
